// src/pages/ForbiddenPage.tsx

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const ForbiddenPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="text-4xl font-bold mb-4">{t('forbiddenPage.title')}</h1>
      <p className="mb-8">{t('forbiddenPage.message')}</p>
      <Button onClick={() => navigate('/')}>{t('forbiddenPage.goHome')}</Button>
    </div>
  );
};

export default ForbiddenPage;